import { render, staticRenderFns } from "./private-sales-merit.vue?vue&type=template&id=01677266&"
import script from "./private-sales-merit.vue?vue&type=script&lang=js&"
export * from "./private-sales-merit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports